import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  getLocalValue,
  LoacalVariables
} from "../commonFunctions/CommonFunctions";
import { Helmet } from "react-helmet";

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  const userType = getLocalValue(LoacalVariables.UserType);
  const name = getLocalValue(LoacalVariables.Name);
  //   const userId = getLocalValue(LoacalVariables.UserId);

  // Optional: Send log to server for auditing
  //   useEffect(() => {
  //     const logAccessDenial = async () => {
  //       try {
  //         await axios.post(
  //           "/api/logs/unauthorized-access",
  //           {
  //             userId,
  //             userType,
  //             name,
  //             path: window.location.pathname,
  //             attemptedAt: new Date()
  //           },
  //           { withCredentials: true }
  //         );
  //       } catch (err) {
  //         console.error("Failed to log unauthorized access", err);
  //       }
  //     };

  //     logAccessDenial();
  //   }, [userId, userType, name]);

  return (
    <React.Fragment>
      <Helmet>
        <title>Unauthorized Page | Willsoar Technologies</title>
        <meta
          name="description"
          content="Oops! The page you’re looking unauthorized for you."
        />
      </Helmet>
      <Box
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(26,32,44,1)"
        px={2}
      >
        <Paper elevation={1} sx={{ p: 4, maxWidth: 500, textAlign: "center" }}>
          <Typography variant="h4" color="error" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Hello <strong>{name}</strong>, your current role is:{" "}
            <strong>{userType}</strong>.
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            You don’t have permission to view this page.
          </Typography>
          <Typography variant="body2" sx={{ fontStyle: "italic", mb: 3 }}>
            If you think this is a mistake, please contact your administrator.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/")}
          >
            Go to Home
          </Button>
        </Paper>
      </Box>
    </React.Fragment>
  );
};

export default Unauthorized;
